import { render, staticRenderFns } from "./avg.vue?vue&type=template&id=a65a94e4&scoped=true&"
import script from "./avg.vue?vue&type=script&lang=js&"
export * from "./avg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65a94e4",
  null
  
)

export default component.exports